import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isReviewReportPageLoading : true,
  loading: false,
  error: null,
  reportData: null,
  validationData: null,
  reportUrl: null,
};

const reviewReportSlice = createSlice({
  name: "reviewReport",
  initialState,
  reducers: {
    fetchReportData: (state) => {
      state.isReviewReportPageLoading = true;
      state.reportData = null;
    },
    fetchReportDataSuccess: (state, action) => {
      state.reportData = action.payload;
      state.isReviewReportPageLoading = false;
    },
    fetchReportDataFailure: (state, action) => {
      state.isReviewReportPageLoading = false;
    },
    fetchReportSasUrl: (state) => {
      state.loading = true;
    },
    fetchReportSasUrlSuccess: (state, action) => {
      state.reportUrl = action.payload?.data?.sasUrl;
      state.loading = false;
    },
    fetchReportSasUrlFailure: (state, action) => {
      state.loading = false;
    },
    saveChangedData: (state, action) => {
      state.loading = true;
    },
    saveChangedDataSuccess: (state, action) => {
      state.loading = false;
      state.validationData = action.payload;
    },
    saveChangedDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to save changes";
    },
    submitReportData: (state, action) => {
      state.loading = true;
    },
    submitReportDataSuccess: (state, action) => {
      state.loading = false;
    },
    submitReportDataFailure: (state, action) => {
      state.loading = false;
    },

    reviewReportAction: (state, action) => {},
    reviewReportActionSuccess: (state, action) => {},
    reviewReportActionFailure: (state, action) => {},
  },
});

export const { actions, reducer, name: sliceKey } = reviewReportSlice;
